var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "lf-dashboard-calendar" }, [
    _vm.url
      ? _c("iframe", {
          attrs: { src: _vm.url, frameborder: "0", allowfullscreen: "" },
        })
      : _c("div", { staticClass: "lf-default-calendar" }, [
          _c("div", { staticClass: "lf-default-calendar-header" }, [
            _c("img", {
              staticClass: "lf-default-calendar-header-icon",
              attrs: {
                src: "https://assets.lefebvre.es/media/logos/web/comunes/icon-cal.svg",
                alt: "Lefebvre calendar icon",
              },
            }),
            _c("span", { staticClass: "lf-default-calendar-header-text" }, [
              _vm._v(_vm._s(_vm.texts.calendarSync)),
            ]),
          ]),
          _c("div", { staticClass: "lf-default-calendar-text" }, [
            _vm._v(_vm._s(_vm.texts.calendarSyncText)),
          ]),
          _c("div", { staticClass: "lf-default-calendar-btn" }, [
            this.urlAccess !== ""
              ? _c(
                  "button",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectCalendar.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.texts.configAccount))]
                )
              : _vm._e(),
          ]),
          _vm.showRefresh
            ? _c("div", { staticClass: "lf-default-calendar-refresh" }, [
                _c("span", {
                  class: [
                    _vm.icons.refresh,
                    "lf-default-calendar-refresh-icon",
                  ],
                }),
                _c(
                  "span",
                  { staticClass: "lf-default-calendar-refresh-text" },
                  [_vm._v(_vm._s(_vm.texts.calendarRefresh))]
                ),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }